import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { injectMutation } from '@tanstack/angular-query-experimental';
import { SvgIconComponent } from 'angular-svg-icon';
import {
  errorToastAction,
  loadingToastAction,
  successToastAction,
} from '../../../core/store/actions/toast.actions';
import { VerificationService } from '../../../core/services/verification.service';
import { AppState } from '../../../core/store';
import { Store } from '@ngrx/store';
import { NzButtonModule } from 'ng-zorro-antd/button';

@Component({
  selector: 'app-email-verification-failed',
  standalone: true,
  imports: [SvgIconComponent, CommonModule, NzButtonModule],
  templateUrl: './email-verification-failed.component.html',
  styleUrl: './email-verification-failed.component.css',
})
export class EmailVerificationFailedComponent {
  verificationService = inject(VerificationService);
  store = inject(Store<AppState>);
  @Input({ required: true }) email!: string;

  resendEmailResponse = injectMutation(() => ({
    mutationFn: (data: { email: string }) =>
      this.verificationService.sendVerificationEmail(data),
    onSuccess: (data) => {
      this.store.dispatch(
        successToastAction({
          autohide: true,
          delay: 7000,
          placement: 'top-end',
          message: 'A new verification link has been sent to your email',
        }),
      );
    },
    onError: (err: any) => {
      this.store.dispatch(
        errorToastAction({
          autohide: true,
          delay: 7000,
          placement: 'top-end',
          message:
            err?.error?.message ||
            'An error occurred while verifying email. Try again shortly',
        }),
      );
    },
  }));

  resendEmail() {
    this.store.dispatch(
      loadingToastAction({
        autohide: false,
        delay: 7000,
        placement: 'top-end',
        message: 'Sending new verification email. Please wait...',
      }),
    );
    this.resendEmailResponse.mutate({ email: this.email });
  }
}
